import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

UploadExcel.propTypes = {
    onUpload: PropTypes.func,
};

export default function UploadExcel({onUpload}) {
  return (
    <Button component="label" variant="contained" startIcon={<CloudUploadIcon />}>
      بارگذاری اکسل
      <VisuallyHiddenInput type="file" accept='excel/*' onChange={(e) => onUpload(e)} />
    </Button>
  );
}